import { useState, type FC } from 'react';
import { Modal } from 'antd';
import { Zap, ZoomIn } from 'lucide-react';

interface TokenInfo {
  input: number;
  outputImage: number;
  total: number;
}

interface ImagePreviewProps {
  previewUrl: string | null;
  lastTokens: TokenInfo | null;
}

const ImagePreview: FC<ImagePreviewProps> = ({ previewUrl, lastTokens }) => {
  const [previewModalOpen, setPreviewModalOpen] = useState(false);

  return (
    <div className="w-48 shrink-0">
      {previewUrl ? (
        <>
          <div
            className="group relative cursor-pointer overflow-hidden rounded-lg border border-slate-200 dark:border-slate-600"
            onClick={() => setPreviewModalOpen(true)}
            title="Cliquer pour agrandir"
          >
            <img src={previewUrl} alt="Featured" className="h-auto w-full object-cover transition-opacity group-hover:opacity-80" />
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/30">
              <ZoomIn className="h-6 w-6 text-white drop-shadow-lg" />
            </div>
            {lastTokens && (
              <div className="absolute bottom-0 left-0 right-0 bg-black/60 px-2 py-1 text-[10px] text-white">
                <div className="flex items-center gap-1">
                  <Zap className="h-2.5 w-2.5" />
                  {lastTokens.total} tokens
                </div>
              </div>
            )}
          </div>

          {/* Full-screen image preview modal */}
          <Modal
            open={previewModalOpen}
            onCancel={() => setPreviewModalOpen(false)}
            footer={null}
            width="85vw"
            centered
            styles={{ body: { padding: 0, display: 'flex', justifyContent: 'center', background: '#000' } }}
          >
            <img src={previewUrl} alt="Preview" className="max-h-[85vh] w-auto rounded" />
          </Modal>
        </>
      ) : (
        <div className="flex h-28 items-center justify-center rounded-lg border-2 border-dashed border-slate-300 dark:border-slate-600">
          <span className="text-xs text-slate-400 dark:text-slate-500">Aucune image</span>
        </div>
      )}
    </div>
  );
};

export default ImagePreview;
